import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {Subject} from 'rxjs';
import * as _ from 'lodash';
import { ActionModel } from 'src/shared/model/action-model';
import { ActionBarConfig } from 'src/shared/model/action-bar-config';
import { ActionBarType } from 'src/shared/constants/action-bar-type.enum';
import { ActionBarAction } from 'src/shared/constants/action-bar.action';
import { CommonConstants } from 'src/shared/constants/common-constants.enum';
import { CustomActionBarTypeEnum } from 'src/shared/constants/custom-action-bar-type.enum';
import { ActionBarService } from 'src/shared/service/action-bar.service';
import { TabBarService } from 'src/shared/service/tab-bar.service';
import { CustomActionEvent } from './service/custom-action-event';
import { ActionBarContext } from './strategy/action-bar-context';



@Component({
  selector: 'dcu-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss']
})
export class ActionBarComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {

  actionNames: ActionModel[] = [];

  otherActionNames: ActionModel[] = [];

  @Input()
  customModal = '';

  @Input()
  actionBarConfig: ActionBarConfig = null;

  disabledAction = true;
  disabledDelete = false;

  @Input()
  selectedRecords = [];

  @Input()
  screenName = 'home';

  @Input()
  multiple = true;

  @Input()
  actionId: string;

  @Output()
  refreshChange: EventEmitter<boolean> = new EventEmitter();

  @Output()
  closeChange: EventEmitter<boolean> = new EventEmitter();

  @Output()
  saveChange: EventEmitter<any> = new EventEmitter();

  @Output()
  saveCloseChange: EventEmitter<any> = new EventEmitter();

  @Output()
  deletingCompleted: EventEmitter<boolean> = new EventEmitter();

  @Output()
  confirm: EventEmitter<boolean> = new EventEmitter();

  @Output()
  cascade: EventEmitter<boolean> = new EventEmitter();

  @Output()
  uploadChange: EventEmitter<FileList> = new EventEmitter();

  @Output()
  addNewCustom: EventEmitter<FileList> = new EventEmitter();

  @Input()
  valueParent: any = {};
  @Input() isEditStatusDate = false;
  @Input() dataFilter: any;

  ngUnsubscribe: Subject<boolean> = new Subject<boolean>();

  defaultActionList: { [key: number]: ActionModel } = {};
  isConfirm = false;

  isShow = true;
  constructor(
    private csEventService: ActionBarService,
    private csTabBarService: TabBarService,
    private actionBarContext: ActionBarContext,
    private csCustomActionEvent: CustomActionEvent
  ) {
    this.buildDefaultActionBars();
  }

  ngOnInit() {
    // listener
    this.csEventService.changeEmitted.takeUntil(this.ngUnsubscribe).subscribe(value => {
      switch (value) {
        case ActionBarAction.DISABLE:
          // this action just called in edit components, check this condition to avoid impacting to listing components
          if (this.actionBarConfig && this.actionBarConfig.isEdit) {
            this.disabledAction = true;
          }
          break;
        case ActionBarAction.ENABLE:
          // this action just called in edit components, check this condition to avoid impacting to listing components
          if (this.actionBarConfig && this.actionBarConfig.isEdit) {
            this.disabledAction = false;
          }
          break;
        case ActionBarAction.SAVE_DONE:
          this.disabledAction = true;
          break;
        case ActionBarAction.NORMAL_REFRESH:
          this.isConfirm = false;
          break;
        case ActionBarAction.DISABLE_NEW:
          this.defaultActionList[ActionBarType.ADD].disabled = true;
          break;
        case ActionBarAction.ENABLE_NEW:
          this.defaultActionList[ActionBarType.ADD].disabled = false;
          break;
        default:
          break;
      }
    });
    this.csTabBarService.changeEmitted.takeUntil(this.ngUnsubscribe).subscribe(value => {
      setTimeout(() => {
        if (value) {
          this.updateStatusByRecords();
        } else {
          this.updateActionByTab();
        }
      }, 0);
    });

    // for custom action event
    this.csCustomActionEvent.changeEmitted.takeUntil(this.ngUnsubscribe).subscribe((customAction: any) => {
      if (!this.actionId || this.actionId === customAction.actionId) {
        switch (customAction.type) {
          case CustomActionBarTypeEnum.NEW:
            this.addNewCustom.emit(customAction.value);
            break;
          case CustomActionBarTypeEnum.CLOSE:
            this.closeChange.emit(customAction.value);
            break;
          case CustomActionBarTypeEnum.SAVE_CLOSE:
            this.saveCloseChange.emit(customAction.value);
            break;
          case CustomActionBarTypeEnum.REFRESH:
            this.refreshChange.emit(customAction.value);
            break;
          case CustomActionBarTypeEnum.DELETE:
            this.deletingCompleted.emit(customAction.value);
            break;
          case CustomActionBarTypeEnum.UPLOAD:
            this.uploadChange.emit(customAction.value);
            break;
          default:
            break;
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (_.size(this.selectedRecords) > 0) {
        this.updateStatusByRecords();
    } else {
      this.updateStatusByRecords(true);
    }

    if (changes.actionBarConfig && !_.isEqual(changes.actionBarConfig.previousValue, changes.actionBarConfig.currentValue)) {
      this.buildActionBar();
    }
  }

  ngAfterViewInit(): void {

  }

  execute(actionType: ActionBarType) {
    const additionalParams = {
      multiple: this.multiple,
      isEditStatusDate: this.isEditStatusDate,
      customModal: this.customModal,
      disabledAction: this.disabledAction,
      isConfirm: this.isConfirm,
      actionId: this.actionId,
      dataFilter: this.dataFilter
    };
    this.actionBarContext.execute(this.actionBarConfig, actionType, this.selectedRecords, additionalParams);
  }

  private updateStatusByRecords(isNotExist = false) {
    // -- isNotExist means there is no selected record , or need to force disable buttons in some cases

    let statusCode;

    if (this.selectedRecords && _.size(this.selectedRecords) > 0) {
      statusCode = Object.values(this.selectedRecords)[0] && Object.values(this.selectedRecords)[0].statusCode;
    }
    this.defaultActionList[ActionBarType.DELETE].disabled = isNotExist;

    if (!this.disabledDelete) {
      this.defaultActionList[ActionBarType.DELETE].disabled = isNotExist;
    }
    if (this.actionBarConfig && this.actionBarConfig.isEdit) {
      // update on edit screen
      this.updateStatusByStatus(isNotExist);
    } else {
      // default of action bar
      this.updateStatusDefault(isNotExist);

    }
  }

  private updateStatusDefault(isNotExist) {
    // ---if not on edit screen, save and save&close won't be disable at the first time.
    this.defaultActionList[ActionBarType.SAVE].disabled = false;
    this.defaultActionList[ActionBarType.SAVE_CLOSE].disabled = false;
  }
  // Applies to only edit mode
  private updateStatusByStatus(isNotExist = false) {
      let statusCode;
      let object;
      if (this.selectedRecords && _.size(this.selectedRecords) > 0) {
        statusCode = Object.values(this.selectedRecords)[0] && Object.values(this.selectedRecords)[0].statusCode;
        object =  Object.values(this.selectedRecords)[0];
      }

      if (this.actionBarConfig.buttonBarConfigs) {
        const buttonBarConfigs = this.actionBarConfig.buttonBarConfigs;
        for (const type of buttonBarConfigs) {
          const foundAction = this.defaultActionList[type.actionBarType];
          if (!_.isUndefined(type.isDisabled)) {
            foundAction.disabled = type.isDisabled;
          }
        }
      }

  }

  private updateActionByTab() {
    let statusCode;
    if (this.selectedRecords && _.size(this.selectedRecords) > 0) {
      statusCode = Object.values(this.selectedRecords)[0] && Object.values(this.selectedRecords)[0].statusCode;
      const fullAction = this.actionBarConfig.isFullAction || false;
      this.defaultActionList[ActionBarType.DELETE].disabled = !fullAction;
      this.defaultActionList[ActionBarType.REFRESH].disabled = !fullAction;
    }

  }

  buildDefaultActionBars() {
    this.defaultActionList[ActionBarType.NEW] = {
      label: CommonConstants.LABEL_NEW,
      icon: CommonConstants.ICON_NEW,
      actionType: ActionBarType.NEW
    };

    this.defaultActionList[ActionBarType.SAVE_CLOSE] = {
      label: CommonConstants.LABEL_SAVE_CLOSE,
      icon: CommonConstants.ICON_SAVE_CLOSE,
      disabled: true,
      actionType: ActionBarType.SAVE_CLOSE
    };

    this.defaultActionList[ActionBarType.SAVE] = {
      label: CommonConstants.LABEL_SAVE,
      icon: CommonConstants.ICON_SAVE,
      disabled: true,
      actionType: ActionBarType.SAVE
    };

    this.defaultActionList[ActionBarType.DELETE] = {
      label: CommonConstants.LABEL_DELETE,
      icon: CommonConstants.ICON_DELETE,
      disabled: true,
      actionType: ActionBarType.DELETE
    };


    this.defaultActionList[ActionBarType.REFRESH] = {
      label: CommonConstants.LABEL_REFRESH,
      icon: CommonConstants.ICON_REFRESH,
      actionType: ActionBarType.REFRESH
    };

    this.defaultActionList[ActionBarType.CLOSE] = {
      label: CommonConstants.LABEL_CLOSE_FORM,
      icon: CommonConstants.ICON_CLOSE_FORM,
      actionType: ActionBarType.CLOSE
    };

    this.defaultActionList[ActionBarType.UPLOAD] = {
      label: CommonConstants.LABEL_UPLOAD,
      icon: CommonConstants.ICON_UPLOAD,
      actionType: ActionBarType.UPLOAD
    };


    this.defaultActionList[ActionBarType.DOWNLOAD] = {
      label: CommonConstants.LABEL_DOWNLOAD,
      icon: CommonConstants.ICON_DOWNLOAD,
      actionType: ActionBarType.DOWNLOAD
    };

    this.defaultActionList[ActionBarType.REPORT] = {
      label: CommonConstants.EXPORT_REPORT_LABEL,
      icon: CommonConstants.ICON_EXCEL_EXPORT,
      actionType: ActionBarType.REPORT
    };

    this.defaultActionList[ActionBarType.CLOSING_METER_DATA] = {
      label: CommonConstants.CLOSING_METER_DATA_LABEL,
      icon: CommonConstants.ICON_CHECK,
      actionType: ActionBarType.CLOSING_METER_DATA
    }
  }

  buildActionBar() {
    if (this.actionBarConfig.buttonBarConfigs) {
      const buttonBarConfigs = this.actionBarConfig.buttonBarConfigs;
      this.actionNames = [];
      for (const type of buttonBarConfigs) {
        const foundAction = this.defaultActionList[type.actionBarType];
        // re-update label if it is existed custom
        if (type.customLabel) {
          foundAction.label = type.customLabel;
        }
        if (type.customIcon) {
					foundAction.icon = type.customIcon;
				}
        if (!_.isUndefined(type.isDisabled)) {
            foundAction.disabled = type.isDisabled;
            if (type.isDisabled) {
              foundAction.customDisplay = true;
              if (type.actionBarType === ActionBarType.DELETE) {
                this.disabledDelete = true;
              }
            }

        }

        if (type.isInOtherAction) {
          this.otherActionNames.push(foundAction);
          return;
        }

        this.actionNames.push(foundAction);
      }
    }

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  // show popup other button
  onTogglePopup() {
    this.isShow = !this.isShow;
  }
}
